
<template>
  <transition name="modal-fade">
    <div class="modal WpModal" v-bind:class="{'show': isModalVisible}" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

    <div class="modal-dialog modal-dialog-centered" v-bind:class="{'modal-lg': largeModal}" role="document">
      <div class="modal-content rounded-corners">
        <slot name="header">
        <!-- <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Modal title</h5>
          <button type="button" class="close" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div> -->
        </slot>
        <div class="modal-body">
          <slot name="body">
            <slot name="headline"><h3>Headline</h3></slot>
            <slot name="text"><p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.</p></slot>


        </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <div class="container-fluid text-center">

              <div v-if="twoButtons" class="row">
                <div class="col-12 col-lg-6">
                   <button type="button" class="btn btn-primary btn-wp" @click="submit"><slot name="firstBtn">Button text</slot></button>
                </div>
                <div class="col-12 col-lg-6">
                    <button type="button" class="btn btn-secondary btn-wp" @click="close"><slot name="closeBtn">Close</slot></button>
                </div>
              </div>
              <div v-else class="row">
                <div class="col">
                  <button type="button" class="btn btn-secondary btn-wp" @click.prevent="close"><slot name="closeBtn">Close</slot></button>
                </div>
              </div>

            </div>
          </slot>
        </div>
      </div>
    </div>

  </div>
 </transition>
</template>



<script>
  export default {
    name: 'vuemodal',


    props: {
    isModalVisible: {
      type: Boolean,
      default: false
    },
    largeModal: {
      type: Boolean,
      default: false
    },
    twoButtons: {
      type: Boolean,
      default: false
    },
    logout: {
      type: Boolean,
      default: false
    },
  },

    methods: {
      close(event) {
        this.$emit('clicked', 'close');
      },
      submit(){
        this.$emit('clicked', 'submit');
      }
    }
  };
</script>


<style>
 .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>



// WEBPACK FOOTER //
// src/components/Generals/Modal.vue